export const SKILLS = {
  js: {
    name: "js",
    label: "JavaScript",
    shortDescription: "yeeting code into the DOM since '95, no cap! 💯🚀",
    color: "#f0db4f",
  },
  ts: {
    name: "ts",
    label: "TypeScript",
    shortDescription: "JavaScript's overachieving cousin who's always flexing 💯🔒",
    color: "#007acc",
  },
  html: {
    name: "html",
    label: "HTML",
    shortDescription: "the internet's granddad, still bussin' fr fr! 💀🔥",
    color: "#e34c26",
  },
  css: {
    name: "css",
    label: "CSS",
    shortDescription: "styling with the ultimate drip, no cap 💁‍♂️🔥",
    color: "#563d7c",
  },
  react: {
    name: "react",
    label: "React",
    shortDescription: "components on components on components 🔄",
    color: "#61dafb",
  },
  vue: {
    name: "vue",
    label: "Vue",
    shortDescription: "the chill pill for your frontend, it hits different! 🟢😌",
    color: "#41b883",
  },
  nextjs: {
    name: "nextjs",
    label: "Next.js",
    shortDescription: "the drama queen of front-end frameworks, and we stan! 👑📜",
    color: "#fff",
  },
  tailwind: {
    name: "tailwind",
    label: "Tailwind",
    shortDescription: "utility classes hitting different fr fr 🌪️🔥",
    color: "#38bdf8",
  },
  nodejs: {
    name: "nodejs",
    label: "Node.js",
    shortDescription: "JavaScript said 'sike, I'm backend now', deadass! 🔙🔚",
    color: "#6cc24a",
  },
  express: {
    name: "express",
    label: "Express",
    shortDescription: "middlewares go dummy hard, no cap! 🚂💨",
    color: "#fff",
  },
  postgres: {
    name: "postgres",
    label: "PostgreSQL",
    shortDescription: "SQL but make it fashion, purr 💅🐘",
    color: "#336791",
  },
  mongodb: {
    name: "mongodb",
    label: "MongoDB",
    shortDescription: "flexin' with that NoSQL drip, respectfully! 💪🍃",
    color: "#336791",
  },
  git: {
    name: "git",
    label: "Git",
    shortDescription: "the code's personal bodyguard, no cap! 🕵️‍♂️🔄",
    color: "#f1502f",
  },
  github: {
    name: "github",
    label: "GitHub",
    shortDescription: "sliding into those pull requests, IYKYK! 🐙",
    color: "#000000",
  },
  prettier: {
    name: "prettier",
    label: "Prettier",
    shortDescription: "making your code not a whole mess, thank u next 🧹✨",
    color: "#f7b93a",
  },
  npm: {
    name: "npm",
    label: "NPM",
    shortDescription: "package manager said 'I gotchu fam', period! 📦💯",
    color: "#fff",
  },
  firebase: {
    name: "firebase",
    label: "Firebase",
    shortDescription: "your app's ultimate wingman 🔥👌",
    color: "#ffca28",
  },
  wordpress: {
    name: "wordpress",
    label: "WordPress",
    shortDescription: "the grandpa of CMS, still rocking that cane 🧓👴",
    color: "#007acc",
  },
  linux: {
    name: "linux",
    label: "Linux",
    shortDescription: "where 'chmod 777' is the ultimate flex 🔓🙌",
    color: "#fff",
  },
  docker: {
    name: "docker",
    label: "Docker",
    shortDescription: "The best containerization! 🐳🔥",
    color: "#2496ed",
  },
  nginx: {
    name: "nginx",
    label: "NginX",
    shortDescription: "reverse proxy go zoom zoom, sheesh! 🚗💨",
    color: "#008000",
  },
  aws: {
    name: "aws",
    label: "AWS",
    shortDescription: "always extra, making everything more complicated 🌐👨‍💻",
    color: "#ff9900",
  },
  gcp: {
    name: "gcp",
    label: "Google Cloud",
    shortDescription: "cloud computing but make it Google vibes ☁️🔥",
    color: "#4285f4",
  },
  vim: {
    name: "vim",
    label: "Vim",
    shortDescription: "exit? In this economy? Ight, imma head out! 🚪🏃",
    color: "#e34c26",
  },
  vercel: {
    name: "vercel",
    label: "Vercel",
    shortDescription: "helps you deploy and go touch grass! 🚀🌿",
    color: "#6cc24a",
  },
};
